export default "__VITE_ASSET__pEuT8LKW__"